function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #232f45;\n      }\n\n      .cls-2 {\n        fill: #222d44;\n      }\n\n      .cls-3 {\n        fill: #253148;\n      }\n\n      .cls-4 {\n        fill: #fefefe;\n      }\n\n      .cls-5 {\n        fill: #f8f9fa;\n      }\n\n      .cls-6 {\n        fill: #eef0f3;\n      }\n\n      .cls-7 {\n        fill: #f5f6f8;\n      }\n\n      .cls-8 {\n        fill: #f6f7f9;\n      }\n\n      .cls-9 {\n        fill: #f4f6f7;\n      }\n\n      .cls-10 {\n        fill: #fcfcfd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M207.23,93.8V265.56h-44V93.8Zm-33.34,34.08h21.36V105.93H173.89Zm21.44,125.78V231.41H174v22.25Zm-10.74-30.42c5.77,0,11-5.61,11.06-11.86,0-7.18-4.25-11.86-10.81-12.07-5.85-.18-10.21,3.27-11,11.84C173.22,217.11,179,223.22,184.59,223.24Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M265.54,93.8V265.2h-44V93.8Zm-32.71,97.55H254.4V168H232.83Zm0,31.62h21.52V199.72H232.87Zm21.55-117.21H233.07v22.17h21.35Zm-11,148.16a10.81,10.81,0,0,0,11.31-11.06c-.12-7.26-4.43-11.86-11.14-11.86s-10.91,4.63-10.91,12A10.53,10.53,0,0,0,243.4,253.92Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M325,93.8V265.21H281V93.8Zm-33.22,97.51h21.31V168.05H291.82ZM313,222.94V199.63H291.81v23.31Zm-21.33-95.07H313V105.94H291.71ZM313.25,231.4H291.82v22.13h21.43Zm-10.83-94.08c-6.43,0-10.87,4.34-10.9,10.59,0,7.23,4.25,12,10.78,12.11,6.74.08,11-4.43,11.14-11.71C313.54,141.57,309.26,137.3,302.42,137.32Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M173.89,127.88V105.93h21.36v21.95Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M195.33,253.66H174V231.41h21.3Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M184.59,223.24c-5.57,0-11.37-6.13-10.79-12.09.83-8.57,5.19-12,11-11.84,6.56.21,10.85,4.89,10.81,12.07C195.63,217.63,190.36,223.27,184.59,223.24Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M232.83,191.35V168H254.4v23.32Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M232.87,223V199.72h21.52V223Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M254.42,105.76v22.17H233.07V105.76Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M243.4,253.92A10.53,10.53,0,0,1,232.66,243c0-7.35,4.22-12,10.91-12s11,4.6,11.14,11.86A10.81,10.81,0,0,1,243.4,253.92Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M291.82,191.31V168.05h21.31v23.26Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M313,222.94H291.81V199.63H313Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M291.71,127.87V105.94H313v21.93Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M313.25,231.4v22.13H291.82V231.4Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M302.42,137.32c6.84,0,11.12,4.25,11,11-.1,7.28-4.4,11.79-11.14,11.71-6.53-.08-10.8-4.88-10.78-12.11C291.55,141.66,296,137.33,302.42,137.32Z",
  transform: "translate(-163.21 -93.8)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "MNaN,NaN,NaN,NaN,NaN,NaN,NaN,NaN,NaN,NaNZ",
  transform: "translate(-163.21 -93.8)"
}));

function SvgInvawareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 161.83,
    height: 171.76,
    viewBox: "0 0 161.83 171.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Invaware Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvawareIcon);
export default __webpack_public_path__ + "static/media/Invaware Icon.154d0476.svg";
export { ForwardRef as ReactComponent };